import script from "./Pos.vue?vue&type=script&setup=true&lang=js"
export * from "./Pos.vue?vue&type=script&setup=true&lang=js"

import "./Pos.vue?vue&type=style&index=0&id=02c8787a&scoped=true&lang=css"

import exportComponent from "F:\\Programs\\Herd\\posLaravel12\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02c8787a"]])

export default __exports__